import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { ADD_USER_PREFERENCE_REQUEST, ADD_USER_PREFERENCE_SUCCESS, ADD_USER_PREFERENCE_ERROR } from '../constants/ActionTypes';
import { push } from 'connected-react-router';
import { addUserPreference as addUserPreferenceLocally } from './modifyUserPreference';

function addUserPreferenceRequest() {
    return {
        type: ADD_USER_PREFERENCE_REQUEST,
    };
}

function addUserPreferenceSuccess() {
    return {
        type: ADD_USER_PREFERENCE_SUCCESS,
    };
}

function addUserPreferenceError(error) {
    return {
        type: ADD_USER_PREFERENCE_ERROR,
        error,
    };
}

export default function addUserPreference(preference, body) {
    return (dispatch, getState, fetch) => {
        const { uberToken, locale, config, router } = getState();
        const { location = {} } = router;
        const { country } = locale;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const request = Person.userPreferenceUpdate({
            baseUrl,
            brandId,
            country,
            preference,
            body,
            uberToken,
            clientId,
        });

        dispatch(
            addUserPreferenceLocally(
                preference,
                body.values.map(({ name }) => name),
            ),
        );
        dispatch(addUserPreferenceRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response.json().then(() => dispatch(addUserPreferenceSuccess()));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(addUserPreferenceError(error));
                throw error;
            });
    };
}
